// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"4b52f3f5","553":"288f5efb","977":"f5c51ba5"}[chunkId] + ".chunk.js";
};